import React, { useEffect, useState } from "react";
import PaginatedTable from "../common/PaginatedTable";
import DTIPages from "../common/DTIPages";
import { View } from "@instructure/ui-view";
import { Text } from "@instructure/ui-text";
import DtiToolbar from "../common/DtiToolbar";
import DtiKpiGrid from "../common/DtiKpiGrid";
import DtiSectionHeading from "../common/DtiSectionHeading";
import DtiOverviewSkeleton from "../common/DtiSkeleton";
import {
  getJobInteractiveLessionRate,
  getInteractiveLessionRate,
  createJobInteractiveLessionRate,
} from "../api/api";

export default function DigitalLession({ iframe = false }) {
  const [data, setData] = useState([]);
  const [totalTeacherCreatedLecture, setTotalTeacherCreatedLecture] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const applyData = (nextData) => {
    setData(nextData);
    setTotalTeacherCreatedLecture(nextData?.totalTeacherCreatedLecture ?? null);
  };

  useEffect(() => {
    let intervalId;
    const fetchData = async () => {
      setIsFetching(true);
      try {
        const dataInteractiveLession = await getInteractiveLessionRate();
        applyData(dataInteractiveLession);

        const job = await getJobInteractiveLessionRate();
        if (["starting", "pending"].includes(job?.workflowState)) {
          setIsLoading(true);
          intervalId = setInterval(async () => {
            const jobStatus = await getJobInteractiveLessionRate();
            if (jobStatus?.workflowState === "done") {
              setIsLoading(false);
              clearInterval(intervalId);
              setIsFetching(true);
              try {
                applyData(await getInteractiveLessionRate());
              } finally {
                setIsFetching(false);
              }
            }
          }, 1000);
        }
      } finally {
        setIsFetching(false);
      }
    };
    fetchData();
    return () => clearInterval(intervalId);
  }, []);

  const handleJob = async () => {
    if (isLoading) return;
    setIsLoading(true);
    await createJobInteractiveLessionRate();
    const intervalId = setInterval(async () => {
      const job = await getJobInteractiveLessionRate();
      if (job?.workflowState === "done") {
        setIsLoading(false);
        clearInterval(intervalId);
        setIsFetching(true);
        try {
          applyData(await getInteractiveLessionRate());
        } finally {
          setIsFetching(false);
        }
      }
    }, 1000);
  };

  const showSkeleton = isFetching || isLoading;

  if (iframe) {
    return (
      <View as="div" margin="small" textAlign="center">
        <Text size="large">Bạn không được quyền truy cập</Text>
      </View>
    );
  }

  if (showSkeleton) {
    return <DtiOverviewSkeleton kpiCount={1} />;
  }

  return (
    <>
      <DtiToolbar isLoading={isLoading} onRefresh={handleJob} />

      <DTIPages
        secondPage={
          <>
            <DtiSectionHeading>Chi tiết giáo viên tạo bài giảng</DtiSectionHeading>
            <div className="dti-detail-block">
              <ul>
                <li>
                  Số giáo viên tạo bài giảng:{" "}
                  <strong>{data?.dataTeacherCreatedLecture?.totalCreatedResult ?? "—"}</strong>
                </li>
              </ul>
            </div>
            <DtiSectionHeading>Danh sách giáo viên</DtiSectionHeading>
            <PaginatedTable
              headers={[
                { id: "user_name", text: "Họ và tên giáo viên", width: "100%" },
              ]}
              rows={data?.dataTeacherCreatedLecture?.dataCreatedResult}
              perPage={10}
            />
          </>
        }
        firstPage={
          <DtiKpiGrid
            items={[
              {
                id: "totalTeacherCreatedLecture",
                label: "Số giáo viên đã tạo bài giảng",
                value: totalTeacherCreatedLecture,
              },
            ]}
          />
        }
      />
    </>
  );
}
